import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PassportInfoComponent } from './passport-info/passport-info.component';
import { PassportInsurancesComponent } from './passport-insurances/passport-insurances.component';
import { PassportComponent } from './passport.component';
import { PassportContainer } from './passport.container';
import {
    WucBalloonModule,
    WucCardModule,
    WucIconModule, WucIconUiModule, WucLinkModule, WucListItemModule, WucListModule,
    WucRackModule,
    WucSkeletonModule, WucTextHighlightModule,
} from '@inshared/website-ui-components';
import { CapitalizeModule } from '@app/shared/pipes/capitalize/capitalize.module';

@NgModule({
    declarations: [
        PassportComponent,
        PassportContainer,
        PassportInsurancesComponent,
        PassportInfoComponent,
    ],
    imports: [
        CommonModule,
        WucSkeletonModule,
        WucCardModule,
        WucBalloonModule,
        CapitalizeModule,
        WucRackModule,
        RouterModule,
        WucIconModule,
        WucListItemModule,
        WucListModule,
        WucLinkModule,
        WucIconUiModule,
        WucTextHighlightModule,
    ],
    exports: [
        PassportContainer,
        PassportInfoComponent,
    ],
})
export class PassportModule {}
